<template>
  <div
    :class="{
      'absolute inset-0 z-50 w-full h-screen': isModalOpen,
    }">
    <div
      class="fixed inset-0 bg-gray-500 transition-opacity bg-opacity-85"
      v-if="isModalOpen"></div>
    <div
      :class="{
        'fixed inset-0 z-10 w-full h-full grid': isModalOpen,
      }">
      <div class="grid grid-rows-[auto_1fr] pt-2 bg-white rounded-md shadow-xl h-full min-h-0">
        <div class="sticky top-0 z-10 p-1 bg-white">
          <div class="flex justify-between p-3 rounded-md bg-cyan-light">
            <h1 class="font-medium text-theme-700">
              {{ $t('question.preview') }}
            </h1>
            <button type="button" @click="toggleModal" v-if="questionnaire">
              <Icon
                :icon="isModalOpen ? '@documents:ic:reduce' : '@documents:ic:expand'"
                class="ml-2 w-4 h-4 text-theme-700" />
            </button>
          </div>
        </div>

        <div class="overflow-y-auto h-full min-h-0">
          <div
            v-if="!questionnaire"
            class="h-44 bg-center bg-cover"
            :class="{
              'bg-[url(/src/assets/images/preview-pattern.svg)]': !questionnaire,
            }"></div>
          <div v-else class="max-w-7xl mx-auto h-full min-h-0 my-3 grid grid-rows-[auto_1fr] gap-4">
            <div class="flex flex-col gap-2 px-4 py-4 w-full border shadow-md">
              <div class="w-full h-8 bg-gray-200 rounded-md"></div>
              <div class="flex gap-2">
                <div class="w-20 h-2 bg-gray-300 rounded-full"></div>
                <div class="w-24 h-2 bg-gray-300 rounded-full"></div>
              </div>
            </div>

            <div class="grid grid-cols-[1fr_2fr] gap-4">
              <div class="p-3 space-y-3 h-full bg-gray-50 rounded-md">
                <BaseSkeletonCard v-for="i in 6" :key="i" />
              </div>
              <component
                v-if="questionnaire"
                :is="activeDetailsComponent"
                :questionnaire="questionnaire"
                :key="'qst-' + props.questionnaire?.id"
                class="w-full h-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, shallowRef, watch, type Component } from 'vue';
import { Icon } from '@iconify/vue';
import QuestionnairesGeneric from './QuestionnairesGeneric.vue';
import QuestionnairesGenericBindingOne from './QuestionnairesGenericBindingOne.vue';
import QuestionnairesGenericBindingTwo from './QuestionnairesGenericBindingTwo.vue';
import BaseSkeletonCard from '../common/BaseSkeletonCard.vue';
import type { Questionnaire } from '@/types/Questionnaires';

const isModalOpen = ref(false);

const props = defineProps<{
  questionnaire: Questionnaire | null;
}>();

const activeDetailsComponent = shallowRef<Component | undefined>(undefined);

watch(
  () => props.questionnaire,
  (newData) => {
    if (!newData) return;

    if (newData.bindingType === 0) activeDetailsComponent.value = QuestionnairesGeneric;
    if (newData.bindingType === 1) activeDetailsComponent.value = QuestionnairesGenericBindingOne;
    if (newData.bindingType === 2) activeDetailsComponent.value = QuestionnairesGenericBindingTwo;
  }
);

function toggleModal() {
  if (!props.questionnaire) return;
  isModalOpen.value = !isModalOpen.value;
}
</script>
